export default function initSearchByIdentificatorForm() {
    const facilitySearchForm = document.getElementById('searchById');
    const openFacilitySearchForm = document.getElementById('searchByIdTooltipIcon');
    const errorFieldForSearchById = document.getElementById('errorFieldForSearchById');
    const inputField = document.getElementById('inputFieldForSearchById');
    // Loader na desktopu i mobilnom siteu je razlicit ID/element
    const loader = document.getElementById('presentationOpacity') === null
        ? document.getElementById('pageLoader') : document.getElementById('presentationOpacity');

    document.addEventListener('click', (event) => {
        if (event.target !== facilitySearchForm && !facilitySearchForm.contains(event.target)
            && event.target !== openFacilitySearchForm) {
            if (facilitySearchForm.style.display === 'block') {
                facilitySearchForm.style.display = 'none';
            }
        }
    });

    openFacilitySearchForm.addEventListener('click', () => {
        if (facilitySearchForm.style.display === 'none') {
            facilitySearchForm.style.display = 'block';
        } else {
            facilitySearchForm.style.display = 'none';
        }
    });

    inputField.addEventListener('focus', () => {
        inputField.classList.remove('errorField');
        if (errorFieldForSearchById.style.display === 'block') {
            errorFieldForSearchById.style.display = 'none';
        }
    });

    facilitySearchForm.addEventListener('submit', (e) => {
        e.preventDefault();

        inputField.classList.remove('errorField');
        if (errorFieldForSearchById.style.display === 'block') {
            errorFieldForSearchById.style.display = 'none';
        }

        $.post(facilitySearchForm.action, $(facilitySearchForm).serialize()).then(({ pathName, error }) => {
            loader.style.display = 'block';
            if (!error && pathName !== '') {
                window.location.href = pathName;
            } else {
                errorFieldForSearchById.style.display = 'block';
                inputField.classList.add('errorField');
                loader.style.display = 'none';
            }
        });
    });
}
